import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect } from "react";
import AppRoutes from "./RouteConfig";
import { AppContextProvider } from "./core/app.context";
import APIProvider from "./apiclient/provider/api-provider";
import "./App.scss";
import {
  registerAxiosIntercepts,
  setAxiosAuthHeaders,
} from "./apiclient/provider/axios";
import { RouterView } from "./core/router.view.component";
import { FooterComponent } from "./core/footer.component";
import { ToastContainer } from "react-bootstrap";
import { Provider } from "react-redux";
import appstore from "./Store";
import { AuthProvider } from "react-oidc-context";
import { RouterViewLocal } from './core/router.local.component';
import { Container, Content } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

export const ReactApp: React.FC = () => {

  useEffect(() => {
    registerAxiosIntercepts();
    setAxiosAuthHeaders();
  }, []);

//   if (auth.isLoading) {
//     return <div>Loading...</div>;
//   }
//   if (auth.error) {
//     return <div>Encountering error... {auth.error.message}</div>;
//   }
//  if (auth.isAuthenticated) {
//     return (
//       <div>
//         <pre> Hello: {auth.user?.profile.email} </pre>
//         <pre> ID Token: {auth.user?.id_token} </pre>
//         <pre> Access Token: {auth.user?.access_token} </pre>
//         <pre> Refresh Token: {auth.user?.refresh_token} </pre>
//         <button onClick={() => auth.removeUser()}>Sign out</button>
//       </div>
//     );
//   }
//   return (
//     <div>
//       <button onClick={() => auth.signinRedirect()}>Sign in</button>
//       <button onClick={() => signOutRedirect()}>Sign out</button>
//     </div>
//   );
  return (
    <AppContextProvider>
      <APIProvider>
        <Provider store={appstore}>
          {/* <AppRoutes /> */}
          <Router>
            <div className="wrapper bg-gray-50">
              <RouterView />
          {/*  <RouterViewLocal/> */}
            </div>
            <FooterComponent />
            <ToastContainer />
          </Router>
        </Provider>
      </APIProvider>
    </AppContextProvider>
  );
};
export default ReactApp;
